const polyfills = [];

if (!Object.entries) {
  polyfills.push(
    import(
      /* webpackChunkName: "polyfill-object-entries" */ 'polyfills/objectEntries'
    )
  );
}

if (!Object.assign) {
  polyfills.push(
    import(
      /* webpackChunkName: "polyfill-object-assign" */ 'polyfills/objectAssign'
    )
  );
}

if (!Array.prototype.includes) {
  polyfills.push(
    import(
      /* webpackChunkName: "polyfill-array-includes" */ 'polyfills/arrayIncludes'
    )
  );
}

if (!Array.prototype.findIndex) {
  polyfills.push(
    import(
      /* webpackChunkName: "polyfill-array-findIndex" */ 'polyfills/arrayFindIndex'
    )
  );
}

if (!Array.prototype.find) {
  polyfills.push(
    import(/* webpackChunkName: "polyfill-array-find" */ 'polyfills/arrayFind')
  );
}

if (typeof Set === 'undefined' || typeof Set.prototype.keys !== 'function') {
  polyfills.push(
    import(/* webpackChunkName: "polyfill-set" */ 'polyfills/set')
  );
}

if (typeof URL !== 'function') {
  polyfills.push(
    import(/* webpackChunkName: "polyfill-url" */ 'polyfills/url')
  );
}

if (!window.Intl) {
  polyfills.push(
    import(/* webpackChunkName: "polyfill-intl" */ 'polyfills/intl')
  );
}

export default polyfills;
